export function padScormTime(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return (
    String(h).padStart(4, '0') +
    ':' +
    String(m).padStart(2, '0') +
    ':' +
    String(sec).padStart(2, '0')
  );
}

export function parseScormTime(timeStr) {
  if (!timeStr || typeof timeStr !== 'string') return 0;
  const parts = timeStr.split(':');
  if (parts.length !== 3) return 0;
  return parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60 + parseInt(parts[2], 10);
}

export function flattenCmi(dataModel) {
  const flat = {};
  if (!dataModel || typeof dataModel !== 'object') return flat;
  const walk = (obj, prefix) => {
    Object.keys(obj).forEach((key) => {
      const val = obj[key];
      const path = prefix ? prefix + '.' + key : key;
      if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
        walk(val, path);
      } else {
        flat[path] = val == null ? '' : String(val);
      }
    });
  };
  if (dataModel.cmi) walk(dataModel.cmi, 'cmi');
  else walk(dataModel, '');
  return flat;
}

export function unflattenCmi(flat) {
  const root = { cmi: {} };
  Object.keys(flat || {}).forEach((path) => {
    const parts = path.replace(/^cmi\./, '').split('.');
    let node = root.cmi;
    for (let i = 0; i < parts.length - 1; i++) {
      if (!node[parts[i]] || typeof node[parts[i]] !== 'object') node[parts[i]] = {};
      node = node[parts[i]];
    }
    node[parts[parts.length - 1]] = flat[path];
  });
  return root;
}

export function lmsWebPrefix() {
  if (typeof window === 'undefined') return '';
  const fromPath = (window.location.pathname || '').match(/^\/(dev|DEMO)(?=\/|$)/i);
  if (fromPath) {
    return '/' + fromPath[1];
  }
  return '';
}

/**
 * /scorm-content/{id}/... requiere Alias Apache (a menudo ausente en DEV).
 * Los ZIP viven en {prefix}/scorm/storage/packages/{id}/.
 */
export function mapScormContentPath(pathname) {
  const marker = '/scorm-content/';
  const idx = String(pathname || '').indexOf(marker);
  if (idx === -1) {
    return pathname;
  }
  const rest = String(pathname).slice(idx + marker.length).replace(/^\/+/, '');
  return lmsWebPrefix() + '/scorm/storage/packages/' + rest;
}

export function resolvePublicAssetPath(url) {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) {
    try {
      const parsed = new URL(url);
      if (parsed.pathname.indexOf('/scorm-content/') !== -1) {
        parsed.pathname = mapScormContentPath(parsed.pathname);
        return parsed.toString();
      }
    } catch (e) {
      return url;
    }
    return url;
  }
  const origin = window.location.origin;
  const path = url.startsWith('/') ? url : '/' + url;
  const mapped = mapScormContentPath(path);
  return origin + mapped;
}

export function isUnsafeStorylinePlayerHtml(html) {
  if (!html || typeof html !== 'string') return false;
  const isStoryline =
    /Storyline/i.test(html) ||
    /publishSource:\s*['"]storyline['"]/i.test(html);
  if (!isStoryline) return false;
  if (
    /StartupPromiseUpgrade|SlidePromiseUpgrade|EngagePromiseUpgrade|MultipleQuizTracking/.test(
      html
    )
  ) {
    return true;
  }
  const m = html.match(/playerVersion:\s*'3\.(\d+)\./);
  return !!(m && parseInt(m[1], 10) >= 125);
}

export function applyFreshAttemptProgress(progress) {
  const base = progress && typeof progress === 'object' ? Object.assign({}, progress) : {};
  base.completionStatus = 'not attempted';
  base.successStatus = 'unknown';
  base.location = '';
  base.suspendData = '';
  base.entry = 'ab-initio';
  base.exit = '';
  base.dataModel = null;
  base.scoreRaw = null;
  base.scoreScaled = null;
  base.freshAttempt = true;
  return base;
}

export async function detectUnsafeStorylineFromLaunch(launchUrl) {
  if (!launchUrl) return false;
  try {
    const res = await fetch(launchUrl, { credentials: 'same-origin' });
    if (!res.ok) return false;
    const html = await res.text();
    return isUnsafeStorylinePlayerHtml(html.slice(0, 20000));
  } catch (e) {
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/scorm/frontend/runtime/utils.js